import React, { useEffect, useRef } from "react";

import PropTypes from "prop-types";
import TextLink from "theme/components/text/TextLink";
import colors from "theme/config/colors";
import { scrollTo } from "core-web/utils/scrollFunctions";
import variables from "theme/config/variables";

const ScrollToButton = ({ className, children, ariaLabel, textColor }) => {
    const scrollToRef = useRef(null);

    const scrollToText = () => {
        const content = document.querySelector(`.${className}`);

        if (content) {
            scrollTo({
                smooth: true,
                top: content.offsetTop - (variables.headerHeight + 12),
            });
        }
    };

    useEffect(() => {
        const content = document.querySelector(`.${className}`);

        if (content && scrollToRef.current) {
            scrollToRef.current.classList.add("clickable");
        }
    }, [className]);

    return (
        <TextLink revertAnimation ref={scrollToRef} aria-label={ariaLabel} color={textColor} onClick={scrollToText}>
            {children}
        </TextLink>
    );
};

ScrollToButton.propTypes = {
    ariaLabel: PropTypes.string,
    children: PropTypes.oneOf([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
    className: PropTypes.string,
    textColor: PropTypes.string,
};

ScrollToButton.defaultProps = {
    ariaLabel: "",
    className: "",
    textColor: colors.black,
};

export default ScrollToButton;
